
import React from 'react';


const UsePage = ()=>{
    return <div>
        UsePage
    </div>
}

export default UsePage;